<template>
  <easy-page-template
      title="取引実績をどのように確認しますか？"
      subtitle="取引実績を確認する方法を、以下の中から選んでください。"
      :image="imageTradeContract">
    <template #buttons>
      <easy-nav
          :icon="iconTradeContractTradeResultContract"
          title="取引契約から検索する"
          to="/edit/list/tradeResult/tradeContracts"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconTradeContractTradeResultData"
          title="データ実装から検索する"
          to="/edit/list/tradeResult/dataImplementations"
          block>
      </easy-nav>
    </template>
  </easy-page-template>
</template>

<script>
import EasyPageTemplate from "@/components/pages/easy/EasyPageTemplate.vue";
import iconTradeContractTradeResultContract from "./assets/icon_trade_contract_trade_result_contract.svg";
import iconTradeContractTradeResultData from "./assets/icon_trade_contract_trade_result_data.svg";
import imageTradeContract from "./assets/image_trade_contract.svg";
import EasyNav from "@/components/pages/easy/EasyNav.vue";

export default {
  name: "TradeResult",
  components: {EasyNav, EasyPageTemplate},
  data() {
    return {
      iconTradeContractTradeResultContract,
      iconTradeContractTradeResultData,
      imageTradeContract
    }
  }
}
</script>

<style scoped>

</style>
